module.exports = __webpack_public_path__ + "img/22.c3ed22ae.jpg";